import React from 'react'
import StagesManager from '../../components/StagesManager';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import Responsive from '../components/Responsive';
// import RoomsHome from './Rooms/RoomsHome';
// import Room from './Rooms/Room';
import { nanoid } from 'nanoid';
import DeskHome from './../Desk/DeskHome';
import HttpServices from '../../utils/Http.services';
// import SocketServices from '../utils/socket.services';
// import { VIEW_NAVBAR_STATE} from "./Desk/DeskHome";
class DeskUserView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // viewState:VIEW_NAVBAR_STATE.Eagle_View
            applets: []
        }

    }


    componentDidMount() {
        // console.log('-============')
        this.init()
        this.getAppletsType()
    }


    componentDidUpdate(prevProps) {
        if (this.props.data != prevProps.data) {
            this.init()
        }
    }

    getAppletsType = () => {
        let applets = []
        HttpServices.request('getMyFramesByType', { features: 'Tasking' }, (fetchResult, fetchError) => {
            if (fetchError) {
                // console.log(fetchError)
                return
            }
            // console.log('desk fetch', fetchResult.info);
            let promises = []
            for (let i = 0; i < fetchResult.info.length; i++) {
                promises.push(new Promise((resolve) => {
                    applets.push({ name: fetchResult.info[i].applet.name, icon: fetchResult.info[i].applet?.image })
                    // console.log('desk fetch', fetchResult.info[i].applet.name);
                    resolve()
                }))
            }
            Promise.all(promises).then(() => {
                this.setState({ applets: applets }, () => {
                    // console.log('applets', this.state.applets);
                })
            })

        })
    }


    init = () => {
        this.props.setWindowInfo({ title: 'Desk', icon: '/assets/icons/portals/desk.svg' })

        // console.log(this.props.data)
        let data = this.props.data
        if (data?.path?.length == 2) {
            this.stageManager.changeStage('room', null, null, true)
        } else if (data?.path?.length == 3) {

        } else {
            this.stageManager.changeStage('home', null, null, true)
        }
    }

    setData = (data, cb) => {
        let newData = this.state.data
        for (const [key, value] of Object.entries(data)) {
            newData[key] = value
        }
        this.setState({ data: newData }, () => {
            if (cb) { cb() }
        })
    }
    createRoom = () => {
        let roomId = nanoid()
        this.props.changeWindow('rooms', { type: 'rooms', path: ['rooms', roomId] })
    }
    // setTime = () => {
    //     HttpServices.request('setTask',{startTime:this.props.startDate,endTime:this.props.endDate,dueTime:""}, (fetchResult, fetchError) => {
    //         this.setState({ isLoadingFiles: false })

    //         if (fetchError) {
    //             console.log('err', fetchError)
    //             return
    //         }
    //         console.log('result', fetchResult)
    //         this.setState({ driveInfo: fetchResult?.info })
    //     })
    // }
    render() {
        return (
            <div className="w-100 d-flex desk window-content-radius back-blur h-100"  >
                <div className=' w-100  h-100 '>

                    <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >
                        <DeskHome
                            applets={this.state.applets}
                            isApplet={this.props.isApplet}
                            currentApplet={this.props.currentApplet}
                            startDate={this.props.startDate} endDate={this.props.endDate}
                            selectApplet={this.props.selectApplet}
                            stage={1} stageName={'home'}
                            initData={this.state.data}
                            setData={this.setData}
                            width={this.props.width}
                            createRoom={this.createRoom}
                            language={this.props.language} />
                        {/* <Room stage={1} stageName={'room'} initData={this.state.data} setData={this.setData} width={this.props.width} height={this.props.height} data={this.props.data} changeWindow={this.props.changeWindow}/> */}
                    </StagesManager>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeskUserView);
